import { upperFirst } from "lodash-es";

export const userFullname = (user) => {
  return `${upperFirst(user?.name)} ${upperFirst(user?.surename)}`.trim();
};
